import { IsNotEmpty, IsString, MaxLength } from 'class-validator';
import type { DeadlineValiditySuggestionSource } from './deadline-management.constants';

const DOCUMENT_TYPE_ID_MAX_LENGTH = 64;

export class DeadlineValiditySuggestionQueryDto {
  @IsString()
  @IsNotEmpty()
  @MaxLength(DOCUMENT_TYPE_ID_MAX_LENGTH)
  documentTypeId!: string;
}

/** Spec §11.1: solo un numero e la sua fonte, mai la riga da cui viene. */
export interface DeadlineValiditySuggestionDto {
  validityMonths: number | null;
  source: DeadlineValiditySuggestionSource | null;
}
